import React from 'react'
import { ScrollView } from 'react-native-gesture-handler';
import { SHr, SLoad, SPage, SText, STheme, SView } from 'servisofts-component2'
import Container from '../../Components/Container';
import Verified_icon from '../../Assets/verified_icon.svg';
import MDL from '../../MDL';

export default class ChecklistTiposVehiculos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            tiposVehiculos: [],
        };
    }

    async componentDidMount() {
        await this.loadTiposVehiculos();
    }

    loadTiposVehiculos = async () => {
        this.setState({ loading: true, error: null });
        try {
            const tiposVehiculos = await MDL.checklist.getChecklistTiposVehiculos();
            const rows = (Array.isArray(tiposVehiculos) ? tiposVehiculos : [])
                .map((item) => ({
                    id: item?.lTipoVehiculo_id,
                    tipo: String(item?.sTipo ?? ''),
                    codigoCentro: String(item?.sCodigoCentro ?? ''),
                }))
                .sort((a, b) => a.tipo.localeCompare(b.tipo, 'es', { sensitivity: 'base' }));
            this.setState({
                tiposVehiculos: rows,
                loading: false,
                error: null,
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error?.message || String(error),
                tiposVehiculos: [],
            });
        }
    }

    renderItem(item, index) {
        const hasCodigo = !!String(item?.codigoCentro || '').trim();
        return (
            <SView key={String(item?.id ?? index)} col={"xs-12"} style={{ borderRadius: 10, borderWidth: 1, borderColor: STheme.color.lightGray, padding: 12, backgroundColor: STheme.color.primary, }} >
                <SText font='AlbertSans' bold fontSize={13} color={STheme.color.text}> lTipoVehiculo_id: {String(item?.id ?? '-')} </SText>
                <SHr height={3} />
                <SText font='AlbertSans' fontSize={12} color={STheme.color.text}> sTipo: {item.tipo || '(vacio)'} </SText>
                <SHr height={3} />
                <SText font='AlbertSans' fontSize={12} color={hasCodigo ? STheme.color.success : STheme.color.danger}> sCodigoCentro: {item.codigoCentro || '(vacio)'} </SText>
            </SView>
        );
    }

    render() {
        const { loading, error, tiposVehiculos } = this.state;
        return (
            <SPage center disableScroll>
                <Container flex>
                    <SView col={"xs-12"} flex style={{ backgroundColor: STheme.color.card, padding: 24, borderRadius: 16 }}>
                        <SView col={"xs-12"} center>
                            <SView col={"xs-12"} center style={{ alignItems: 'center' }} row>
                                <Verified_icon width={18} height={18} fill={STheme.color.secondary} style={{ marginRight: 8 }} />
                                <SText font='AlbertSans' center fontSize={24} color={STheme.color.secondary}>TIPOS DE VEHICULOS</SText>
                            </SView>
                            <SHr height={10} />
                            <SView col={"xs-12"} height={1} style={{ backgroundColor: STheme.color.lightGray }} />
                            <SHr height={10} />
                            <SText font='AlbertSans' center fontSize={14} color={STheme.color.text}>Lista obtenida desde checklist_tipos_vehiculos</SText>
                            <SHr height={10} />
                        </SView>
                        <SView col={"xs-12"} flex style={{ minHeight: 0 }}>
                            <ScrollView
                                style={{ flex: 1, width: '100%' }}
                                contentContainerStyle={{ paddingBottom: 12 }}
                                keyboardShouldPersistTaps="handled"
                                showsVerticalScrollIndicator
                            >
                                {loading ? (
                                    <SView col={"xs-12"} center style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <SLoad />
                                        <SHr height={10} />
                                        <SText center color={STheme.color.text}>Cargando tipos de vehiculos...</SText>
                                    </SView>
                                ) : null}
                                {error ? (
                                    <SView col={"xs-12"}>
                                        <SText center color={STheme.color.danger}>{error}</SText>
                                    </SView>
                                ) : null}
                                {!loading && !error && tiposVehiculos.length <= 0 ? (
                                    <SView col={"xs-12"}>
                                        <SText center>No hay tipos de vehiculos.</SText>
                                    </SView>
                                ) : null}
                                {!loading && !error ? tiposVehiculos.map((item, index) => (
                                    <SView key={String(item?.id ?? index)} col={"xs-12"}>
                                        {this.renderItem(item, index)}
                                        <SHr height={8} />
                                    </SView>
                                )) : null}
                            </ScrollView>
                        </SView>
                    </SView>
                </Container>
                <SHr height={20} />
            </SPage>
        );
    }
}